import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d50c41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Att ta sig dit med tåg", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Boende", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Förberedelser för Vandringen", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Kolla upp aktuell status om vandringsleden."),
  /*#__PURE__*/_createElementVNode("li", null, "Bära bekväma, stadiga vandringsskor."),
  /*#__PURE__*/_createElementVNode("li", null, " Ha med en påfyllningsbar vattenflaska för att hålla dig hydrerad. "),
  /*#__PURE__*/_createElementVNode("li", null, "Ta med en hatt, solkräm och solglasögon för solskydd."),
  /*#__PURE__*/_createElementVNode("li", null, "Packa lättare snacks, som energibars och frukt."),
  /*#__PURE__*/_createElementVNode("li", null, " Kolla väderprognosen och var beredd på förändrade förhållanden. ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Vandringens upplevelse", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.cinqueterrehike.com/en/cinque-terre-trails",
  target: "_blank",
  rel: "noopener noreferrer"
}, " aktuell status ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Genom byarna", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Monterosso al Mare"),
    /*#__PURE__*/_createTextVNode(": Koppla av på den sandiga stranden och njut av lokala skaldjur. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Vernazza"),
    /*#__PURE__*/_createTextVNode(": Beundra de färgglada husen och njut av en gelato vid hamnen. Eller varför inte ta ytterligare ett bad vid den steniga Vernazza Beach och förundras över det kristallklara vattnet. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Corniglia"),
    /*#__PURE__*/_createTextVNode(": Utforska den charmiga stadsplatsen och smaka det berömda Cinque Terre-vinet. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Manarola"),
    /*#__PURE__*/_createTextVNode(": Fånga de ikoniska vyerna från klippstigarna. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Riomaggiore"),
    /*#__PURE__*/_createTextVNode(": Vandra genom smala gränder och prova de regionala pastarätterna. ")
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tid och svårighetsgrad", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Lokal mat", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Focaccia: Njut av detta liguriska plattbröd, ofta toppat med olivolja och ö rter. "),
  /*#__PURE__*/_createElementVNode("li", null, " Pesto: Smaka på det autentiska Genovese pestot gjort med färsk basilika, pinjenötter och parmesan. "),
  /*#__PURE__*/_createElementVNode("li", null, " Skaldjur: Frossa i färska fångster från Liguriska havet, som ansjovis och bläckfisk. "),
  /*#__PURE__*/_createElementVNode("li", null, " Sciacchetrà: Sippa på det lokala söta vinet, ett perfekt sätt att avsluta din vandringsdag. ")
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'CinqueTerreGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).CinqueTerreGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Cinque Terre",
      backgroundImageClass: "background-vernazza"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, null, {
            default: _withCtx(() => [
              _createTextVNode(" Utforska de hisnande landskapen i Cinque Terre genom en oförglömlig vandringsupplevelse längs den vackra italienska Rivieran. Gör dig redo för en resa fylld av natursköna stigar, charmiga byar och läcker lokal mat. "),
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createTextVNode(" Börja ditt äventyr i Cinque Terre med en naturskön tågresa till La Spezia, regionens port. Från La Spezia, anslut till det lokala tåget som stannar vid var och en av de fem pittoreska byarna: Monterosso al Mare, Vernazza, Corniglia, Manarola och Riomaggiore. Se till att kontrollera tågschemat. Du behöver ett Cinque Terre Card som ger tillgång till stigarna. Har du begränsat antal resdagar på ditt interrailkort går det också att köpa till obegränsade tågresor inom regionen med ett Cinque Terre Card. "),
              _hoisted_5,
              _hoisted_6,
              _createVNode(CustomPic, {
                picturePath: "pictures/vernazza-italien.jpg",
                height: "12rem"
              }),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" För en autentisk upplevelse, överväg att bo på någon av de mysiga gästhusen eller familjeägda bed and breakfasts i hjärtat av Cinque Terre-bynerna. Varje by har sin unika charm, från den livliga atmosfären i Monterosso till den lugna charmen i Manarola. Boka ditt boende i god tid, särskilt under högsäsong. "),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _createTextVNode(" Innan du ger dig ut på din vandringsäventyr, se till att: "),
              _hoisted_13,
              _hoisted_14,
              _createTextVNode(" Cinque Terre erbjuder ett nätverk av väl underhållna stigar som förbinder byarna. Den mest kända stigen är Sentiero Azzurro (Blå Stigen), som ger fantastiska kustvyer. Varje del av stigen erbjuder ett unikt perspektiv av landskapet, från terrasserade vingårdar till panoramautsikt över Liguriska havet. "),
              _hoisted_15,
              _hoisted_16,
              _createTextVNode(" Vandringsleden som väldigt vackert slingrar sig genom den varierande naturen kräver dessvärre en hel del underhåll. Det är inte ovanligt att en eller flera delar av leder är nedstängda för omfattande underhåll. Se därför till att kolla upp "),
              _hoisted_17,
              _createTextVNode(" innan avfärd. Skulle någon sträcka mellan två byar vara avstängd går det enkelt att ta tåget i stället. "),
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _createTextVNode(" När du vandrar från by till by, ta dig tid att utforska den lokala kulturen: "),
              _hoisted_21,
              _hoisted_22,
              _createTextVNode(" Hela Sentiero Azzurro-stigen tar cirka 5-6 timmar, beroende på din takt och valda sektioner. Vissa delar kan innebära branta stigningar och nedstigningar, så välj stigar som matchar din konditionsnivå. Det är lämpligt att börja tidigt på dagen för att undvika middagsvärmen. "),
              _hoisted_23,
              _createTextVNode(" Förkovra dig i de underbara smakerna av Cinque Terre genom att prova lokala specialiteter: "),
              _hoisted_24,
              _createTextVNode(" Börja din Cinque Terre-vandringsäventyr där varje steg avslöjar skönheten i den italienska kusten. Fånga magin i landskapet, fördjupa dig i den lokala kulturen och njut av de läckra smakerna i denna förtrollande region. ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})